var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { systemSxFromProps } from '../system';
/* Margin */
export var margin = [
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
];
/* Padding */
export var padding = [
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
];
/* Space */
export var space = __spreadArray(__spreadArray([], margin, true), padding, true);
/**
 * Convenience method for forwarding styles from the `space` system key
 * @see systemSxFromProps
 */
export var spaceSxFromProps = function (props) {
    return systemSxFromProps(props, space);
};
